export default "__VITE_ASSET__1fa5a08b__"